<script setup lang="ts">
import { Button } from '@collector/shared-ui'
import { Incident } from '@collector/sportsapi-client'
import Dropdown from '@desktop/components/Dropdown.vue'

interface Props {
  incident: Incident
}
defineProps<Props>()

type Emits = {
  click: []
}
defineEmits<Emits>()
</script>

<template>
  <Dropdown placement="left">
    <template #trigger>
      <Button
        class="bg-error-5 border-error-5 hover:bg-error-7 hover:border-error-7 text-neutral-10 cursor-pointer"
        icon="xmark"
        size="xs"
        square
      />
    </template>
    <template #content="{ hide }">
      <div class="text-xs font-bold">
        <div class="text-neutral-dark-6 pb-2 text-center">Confirm delete?</div>
        <div class="flex gap-x-4">
          <span
            class="text-neutral-dark-0 cursor-pointer"
            @click="hide"
          >
            Cancel
          </span>
          <span
            class="text-error-5 cursor-pointer underline"
            @click="
              () => {
                $emit('click')
                hide()
              }
            "
          >
            Confirm
          </span>
        </div>
      </div>
    </template>
  </Dropdown>
</template>
